import Konva from 'konva/konva'
import XScale from './x-scale'

export default class XScaleLayer extends Konva.Layer {
  constructor ({ name }) {
    super({ name })
  }

  init ({ timeFrom, timeTo, yOffset, width }) {
    Object.assign(this, { timeFrom, timeTo, yOffset, width })

    this._render()
  }

  _render () {
    this.destroyChildren()

    const { timeFrom, timeTo, yOffset, width } = this

    const xScale = new XScale({
      width,
      yOffset,
      timeFrom,
      timeTo
    })
    xScale.render()
    this.add(xScale)

    this.draw()

    this.xScale = xScale
    this.yOffset += xScale.height
  }
}
